import {
  fetch,
  normalize,
  extractHubURL, normalizeExcept,
} from '../../utils/dataAccess';
import {filterAction, sortAction} from "../../utils/filterAndSortUtils";

export function error(error) {
  return { type: 'TRANSACTION_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'TRANSACTION_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'TRANSACTION_LIST_SUCCESS', retrieved };
}

export function list(page = 'transactions') {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {
        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch({ type: 'TRANSACTION_LIST_RESET' });
  };
}

export function resetFilters() {
  return dispatch => {
    dispatch('TRANSACTION_LIST_FILTER', null);
  }
}

export function filter(filtersData, filtersName = 'transactions') {
  return filterAction('TRANSACTION_LIST_FILTER', filtersName, filtersData)
}

export function sort(sortData) {
  return sortAction('TRANSACTION_LIST_SORT', 'transactions', sortData)
}
